import { gql } from '@apollo/client'

export const SEND_MESSAGE_MUTATION = gql`
  mutation sendMessage($request: SendMessageRequest) {
    sendMessage(request: $request) {
      status
    }
  }
`
